<div>
    <app-external-scrollbar targetSyncScroll="6"
        [targetBaseWidth]="tableHolder6"></app-external-scrollbar>
    <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder6
        syncScroll="6">
        <table nxTable nxSort class="enquiry" (sortChange)="sortTable($event, 'data')" aria-label="claimDataTableDesc">
            <thead>
                <tr nxTableRow>
                    <th nxHeaderCell nxSortHeaderCell="claimNo">Claim No.</th>
                    <th nxHeaderCell nxSortHeaderCell="claimDescription">
                        Claim Type
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="lossDate">
                        Claim Loss Date
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="claimCode">
                        Claim Code
                    </th>
                </tr>
            </thead>
            <tbody>
                @if (data !== null && data.length !== 0) {
                    @for(item of data; track item) {
                    <tr nxTableRow>
                        <td nxTableCell>{{ item.claimNo }}</td>
                        <td nxTableCell>{{ item.claimDescription }}</td>
                        <td nxTableCell>{{ item.lossDate | date : "dd/MM/yyyy" }}</td>
                        <td nxTableCell>{{ item.claimCode }}</td>
                    </tr>
                    }
                }@else {
                    <tr nxTableRow>
                        <td nxTableCell colspan="4" class="std-ta-center">NO DATA</td>
                    </tr>
                }
                
            </tbody>
        </table>
    </div>
</div>